export enum NetworkAssetTypes {
    TS = 1,
    F33KV = 2,
    SS = 3,
    F11KV = 4,
    DT = 5
  }
  